import parse from 'html-react-parser';
import sanitizeHtml from '../../helpers/sanitizeHtmlHelper';
import './richText.css';
import './printContent.css';
// Confluence-authored KB articles arrive as body.view markup with no styling of
// their own; Confluence Cloud has no standalone article stylesheet to borrow
// (the space content-styles endpoint is empty and the look-and-feel API is
// outside this token's scope). These rules are scoped to .richText.
import './confluence.css';

const parseOptions = {
    replace: (domNode) => {
        if (domNode.attribs) {
            Object.keys(domNode.attribs).forEach(key => {
                if (!/^[a-zA-Z_][a-zA-Z0-9_:-]*$/.test(key)) {
                    delete domNode.attribs[key];
                }
            });
        }
    }
};

// const richText = (props) => {return parse(`<div class='richText print-content'>${props.children}</div>`, parseOptions)};
const richText = (props) => {return parse(sanitizeHtml(`<div class='richText print-content'>${props.children}</div>`, parseOptions))};

export default richText;
